import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CertifyService {

  public baseUrl=environment.apiUrl;
  constructor(private http: HttpClient) { }

  public getallCertificates(){
    var res=this.http.get(this.baseUrl+"certify",{observe:'response'});
    return res;
  }

  public getCertificate(number){
    var data={
      searchData:number
    }
    var res=this.http.post(this.baseUrl+"certify/fetch",data,{observe:'response'});
    return res;
  }
}
